import styled from "styled-components";

export const CommerceLandingPageContainer = styled.div<{ isMobileScreen: boolean }>`
	margin-top: ${({ isMobileScreen }) =>
		isMobileScreen ? `70px` : `10px`};
	@media only screen and (min-width: 1025px) {
		background-image: url("/AG_LandingPage/background_1.png"),
			url("/AG_LandingPage/background_2.png");
		background-repeat: no-repeat;
		display: block;
		justify-content: center;
		background-position: top right, bottom left;
		background-size: auto 34%, 40% auto;
		.get-started-container {
			height: 350px;
		}
		.container {
			padding: 0 15px;
			height: 600px;
		}
	}

	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		background-image: url("/AG_LandingPage/background_1.png"),
			url("/AG_LandingPage/background_2.png");
		background-repeat: no-repeat;
		display: block;
		justify-content: center;
		background-position: top right, bottom left;
		background-size: auto 20%, 40% auto;
		.get-started-container {
			height: 350px;
		}
		.container {
			padding: 0 15px;
			height: 600px;
		}
		.mid-container {
		}

		.feature-items {
			display: inline-flex;
			max-width: 1142px;
			width: 90%;
			margin: 0 auto;
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 768px) {
		background-image: url("/AG_LandingPage/background_1.png");
		background-repeat: no-repeat;
		background-position: top right;
		background-size: 100%;
		display: block;
		justify-content: center;
		.get-started-container {
			background-color: rgb(82 141 183);
		}
	}

	@media only screen and (max-width: 640px) {
		background-image: url("/AG_LandingPage/background_1.png");
		background-position: top right;
		background-size: 100%;
		background-repeat: no-repeat;
		display: block;
		justify-content: center;
		.get-started-container {
			background-color: rgb(82 141 183);
		}
	}
`;

export const ImageContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	img {
		width: 100%;
		height: auto;
	}
`;

export const TopContent = styled.div`
	width: 100%;
	margin: 0 auto;

	.sub-header {
		padding-right: 50%;
	}

	.top-content {
		max-width: 1142px;
		width: 90%;
		margin: 0 auto;
	}

	@media only screen and (min-width: 1025px) {
		display: block;
		justify-content: center;
		gap: 25px;
		padding: 50px 0;
		.mid-mobile {
			display: none;
		}
	}

	@media only screen and (min-width: 1025px) and (max-width: 1512px) {
		.sub-header {
			padding-right: 30%;
			font-size: 1.125rem;
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		display: block;
		justify-content: center;
		gap: 25px;
		padding: 30px 0px;
		.sub-header {
			padding-right: 30%;
		}
		.title-top {
			font-size: 26px;
		}
		.title-mid {
			font-size: 26px;
		}
		.mid-mobile {
			display: none;
		}
		.sub-header {
			font-size: 0.875rem;
			text-align: left;
			color: rgb(88 88 91);
			padding: 10px 0px;
			padding-right: 35%;
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 767px) {
		display: block;
		justify-content: center;
		gap: 25px;
		padding: 20px 0px;
		.title-top {
			font-size: 1.625rem;
		}
		.title-mid {
			display: none;
			font-size: 1.625rem;
		}
		.sub-header {
			font-size: 1.25rem;
			text-align: left;
			color: rgb(88 88 91);
			padding: 30px 0px;
		}
		p {
			font-size: 0.875rem;
		}

		.title-mid-mobile {
			font-size: 1.625rem;
		}
	}

	@media only screen and (max-width: 640px) {
		display: block;
		justify-content: center;
		gap: 25px;
		padding: 20px 0px;
		.title-top {
			font-size: 1.625rem;
		}
		.title-mid {
			display: none;
			font-size: 1.625rem;
		}
		.sub-header {
			font-size: 1.25rem;
			text-align: left;
			color: rgb(88 88 91);
			padding: 30px 0px;
		}
		p {
			font-size: 0.875rem;
		}
	}
	.title-mid-mobile {
		font-size: 1.625rem;
	}
`;

export const MidContainer = styled.div`
	background-color: #b6c8d640;
`;
export const FeatureContainer = styled.div`
	background-color: #ffffff;
	.Feature-content {
		max-width: 1142px;
		margin: 0 auto;
		width: 90%;
		display: block;
	}

	@media only screen and (min-width: 1025px) {
		padding: 50px 50px;
		.feature-tile-mid {
			font-size: 1.875rem;
		}
		.feature-title {
			font-size: 1.375rem;
		}
		.feature-des {
			font-size: 1.125rem;
			color: rgb(88 88 91);
		}
		.feature-tile-mid-mobile {
			display: none;
		}
	}
	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		padding: 30px 0px;

		.feature-tile-mid {
			display: none;
			font-size: 1.25rem;
		}
		.feature-tile-mid-mobile {
			font-size: 1.625rem;
			font-weight: bold;
		}
		.feature-title {
			font-size: 1.25rem;
		}
		.feature-des {
			font-size: 1.125rem;
			color: rgb(88 88 91);
			text-align: left;
		}
	}
	@media only screen and (min-width: 640px) and (max-width: 768px) {
		padding: 30px 0px;
		.feature-items {
			display: block;
		}
		.feature-tile-mid {
			display: none;
			font-size: 1.25rem;
		}
		.feature-tile-mid-mobile {
			font-size: 1.625rem;
			font-weight: bold;
		}
		.feature-title {
			font-size: 1.25rem;
		}
		.feature-des {
			font-size: 1.125rem;
			color: rgb(88 88 91);
			text-align: left;
		}
	}
	@media only screen and (max-width: 640px) {
		padding: 30px 0px;

		.feature-tile-mid {
			display: none;
			font-size: 1.25rem;
		}
		.feature-tile-mid-mobile {
			font-size: 1.625rem;
			font-weight: bold;
		}
		.feature-title {
			font-size: 1.25rem;
		}
		.feature-des {
			font-size: 1.125rem;
			color: rgb(88 88 91);
			text-align: left;
		}
	}
`;

export const MidContent = styled.div`
	display: inline-flex;
	width: 100%;

	.mid-content {
		max-width: 1142px;
		width: 90%;
		margin: 0 auto;
	}

	@media only screen and (min-width: 1025px) {
		padding: 50px 0;
	}
	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		padding: 30px 0;

		h1 {
			font-size: 1.25rem;
		}
		p {
			font-size: 0.75rem;
		}
	}
	@media only screen and (min-width: 641px) and (max-width: 767px) {
		padding: 30px 0;

		h1 {
			font-size: 1.5rem;
		}
		p {
			font-size: 14px;
		}
	}
	@media only screen and (max-width: 640px) {
		padding: 30px 0;

		h1 {
			font-size: 1.5rem;
		}
		p {
			font-size: 0.875rem;
		}
	}
`;

export const MidContentTitle = styled.div`
	display: block;
	align-items: center;
	justify-content: center;
	@media only screen and (min-width: 1025px) {
		padding: 50px 50px;
	}

	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		padding: 30px;
	}

	@media only screen and (min-width: 641px) and (max-width: 767px) {
	}

	@media only screen and (max-width: 640px) {
	}
`;
export const MidContentDes = styled.div`
	display: inline-flex;
`;

export const TitleCustomMid = styled.h1`
	color: #2c76aa;
	font-size: 2.875rem;
	font-weight: bold;
`;

export const TitleCustomTop = styled.h1`
	font-size: 2.875rem;
`;

export const H1 = styled.h1`
	text-align: center; /* Centers the content horizontally */
	font-size: 45px;
`;

export const FeaturesComponent = styled.div`
	align-items: center;
	display: block;
	width: 100%;
	padding: 15px 15px;
`;

export const HIWComponent = styled.div`
	background-color: #b6c8d640;
	align-items: center;
`;

export const HIWContent = styled.div`
	@media only screen and (min-width: 641px) {
		max-width: 1142px;
		width: 90%;
		margin: 0 auto;
	}

	@media only screen and (min-width: 1025px) {
		#hiw-sm {
			display: none;
		}
		padding: 50px 0;
		#hiw-title {
			font-size: 1.75rem;
			font-weight: bold;
			text-align: left;
		}
		#hiw-title-des {
			font-size: 1.75rem;
			text-align: left;
		}
		h2 {
			color: #58585b;
			font-size: 1.125rem;
			font-weight: bold;
			text-align: left;
		}
		p {
			color: #7c7d80;
			font-size: 1.125rem;
		}
		.Showcase-item {
			padding: 16px 0px;
		}
		.hiw-img-content {
			padding: 20px 0px;
		}
	}

	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		#hiw-sm {
			display: none;
		}
		padding: 50px 0;
		#hiw-title {
			font-size: 1.75rem;
			font-weight: bold;
			text-align: left;
		}
		#hiw-title-des {
			font-size: 1.75rem;
			text-align: left;
		}
		h2 {
			color: #58585b;
			font-size: 0.875rem;
			font-weight: bold;
			text-align: left;
		}
		p {
			text-align: justify;
			color: #7c7d80;
			font-size: 0.875rem;
		}
		.Showcase-item {
			padding: 10px 0px;
			// padding-right: %;
		}
		.hiw-img-content {
			padding: 20px 0px;
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 768px) {
		padding: 5% 0;
		#hiw-lg {
			display: none;
		}
		.HIW-content {
			display: block;
		}
		img {
			width: 100%;
			height: auto;
		}
		#hiw-title {
			font-size: 1.625rem;
			font-weight: bold;
			text-align: left;
		}
		#hiw-title-des {
			font-size: 1.625rem;
			text-align: left;
		}
		h2 {
			color: #58585b;
			font-size: 1rem;
			font-weight: bold;
			text-align: left;
		}
		p {
			text-align: left;
			color: #7c7d80;
			font-size: 0.9375rem;
		}
		.Showcase-item {
			padding: 1% 0px;
			padding-right: 10%;
		}
		.hiw-img-content {
			padding: 20px 0px;
		}
	}

	@media only screen and (max-width: 768px) {
		#hiw-lg {
			display: none;
		}
		img {
			width: 100%;
			height: auto;
		}
		#hiw-title {
			font-size: 1.625rem;
			font-weight: bold;
		}
		#hiw-title-des {
			font-size: 26px;
		}
		h2 {
			color: #58585b;
			font-size: 1.25rem;
			font-weight: bold;
		}
		p {
			color: rgb(88 88 91);
			font-size: 1.125rem;
			padding-left: 22px;
		}
		.hiw-img-content {
			padding: 0px 0px;
		}
		.Showcase-item {
			padding: 10px 0px;
		}
	}
`;
export const HIWImg = styled.div`
	display: flex;
	text-align: center;
	justify-content: center;

	@media only screen and (max-width: 768px) {
	}
`;
export const HIWContentTitile = styled.div`
	display: block;
	padding: 10px 0;

	@media only screen and (max-width: 641px) {
		max-width: 1142px;
		width: 90%;
		margin: 0 auto;
	}
`;
export const GetStartedComponent = styled.div`
	background-color: rgba(67, 144, 186, 0.87);
	display: block;
	text-align: center;
	.flex {
		justify-content: center;
	}
	@media only screen and (min-width: 1025px) {
		border-radius: 5px;
		padding: 30px 0px;
		#get-started-button {
			background-color: #e12626;
		}
		#get-started-title-top {
			color: #ffffff;
			font-size: 2.1875rem;
		}
		#get-started-title-bottom {
			color: #ffffff;
			font-size: 2.25rem;
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		padding: 30px 0px;
		border-radius: 5px;
		#get-started-button {
			background-color: #e12626;
		}
		#get-started-title-top {
			color: #ffffff;
			font-size: 1.5rem;
		}
		#get-started-title-bottom {
			color: #ffffff;
			font-size: 1.5rem;
		}
	}

	@media only screen and (min-width: 641px) and (max-width: 767px) {
		padding: 5% 0px;
		border-radius: 5px;
		#get-started-button {
			background-color: #e12626;
		}
		#get-started-title-top {
			color: #ffffff;
			font-size: 1.25rem;
		}
		#get-started-title-bottom {
			color: #ffffff;
			font-size: 1.25rem;
		}
	}

	@media only screen and (max-width: 640px) {
		padding: 5% 0px;
		border-radius: 5px;
		#get-started-button {
			background-color: #e12626;
		}
		#get-started-title-top {
			color: #ffffff;
			font-size: 1.25rem;
		}
		#get-started-title-bottom {
			color: #ffffff;
			font-size: 1.25rem;
		}
	}
`;
export const FeaturesTitle = styled.h1`
	text-align: center;
	font-weight: bold;
	font-size: 1.5rem;
`;

export const FeaturesDes = styled.p`
	// text-align: justify;
	font-size: 0.875rem;
`;

export const FeaturesDetail = styled.p`
	text-align: center;
	width: 100%; /* Ensures the text takes up the full width available */
`;

export const SubHeader = styled.p`
	// text-align: justify;
	color: #637381;
`;

export const AGButton = styled.button<{ type?: "primary" | "default" }>`
	background-color: #2c76aa;
	border-radius: 5px;
	border-radius: 5px;
	margin-top: 10px;
	height: 40px;
	width: 150px;
	color: #ffffff;
	font-size: 1.0625rem;
	&:hover,
	&:focus {
		opacity: 0.9;
	}
`;

export const Div = styled.div``;
